import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { CmsCollection, CmsTeaser } from '@fcom/core-api';

@Component({
  selector: 'cms-marketing-activity-blocks',
  templateUrl: './cms-marketing-activity-blocks.component.html',
  styleUrls: ['./cms-marketing-activity-blocks.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsMarketingActivityBlocksComponent {
  content = input.required<CmsCollection<CmsTeaser>>();

  mappedContent = computed(() => {
    const content = this.content();
    return {
      ...content,
      items: (content.items ?? []).map((item) => ({
        ...item,
        target: {
          ...item.target,
          title: item.linkText,
        },
      })),
    };
  });
}
